import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

export const DetailContainer = styled.div`
    min-height: 3rem;
`;

export const Detail = ({
    name,
    children,
    className,
}: PropsWithChildren<{ name: string | ReactNode; className?: string }>) => (
    <DetailContainer className="flex-row flex-nowrap align-start f-14">
        <div className="text-nowrap bold">{name}:</div>
        <div className={`${className || ''} ml-10`}>{children}</div>
    </DetailContainer>
);
